export const common = {
  getMore: 'მეტის მიღება',
  account: 'ჩემი ანგარიში',
  error: 'დაფიქსირდა შეცდომა. გთხოვთ, სცადოთ მოგვიანებით.',
  menu: {
    security: 'პაროლი და უსაფრთხოება',
    promoCode: 'პრომო კოდის გამოყენება',
    logout: 'გასვლა',
  },
  initializer: {
    init: 'ინიციალიზაცია',
  },
  logoutConfirm: {
    title: 'გსურთ გასვლა?',
    description: 'გთხოვთ, დაადასტუროთ.',
    apply: 'დადასტურება',
    reject: 'გაუქმება',
  },
  promoCodeModal: {
    title: 'გაქვთ <b>პრომო კოდი?</b>',
    description: 'გამოიყენეთ პრომო კოდი b-coin-ების მისაღებად',
    code: {
      placeholder: 'პრომო კოდი',
    },
    submit: 'გამოყენება',
    activationSuccess: 'თქვენ მიიღეთ {{coins}} b-coin',
  },
  cookies: {
    title: 'Cookie პარამეტრები',
    text: 'ჩვენ ვიყენებთ cookie-ებს საიტის ძირითადი ფუნქციებისთვის და იმისთვის, რომ უკეთ გავიგოთ, როგორ იყენებთ ჩვენს საიტს. <1>კონფიდენციალურობის პოლიტიკა</1>',
    accept: 'გასაგებია',
    acceptMobile: 'ყველა cookie-ის დაშვება',
  },
  missingTranslation: 'თარგმანი ვერ მოიძებნა',
  saveProfileError: 'პროფილის შენახვა ვერ მოხერხდა',
  fieldRequired: 'ველი სავალდებულოა',
};
